import { JsonObject } from '@/lib/helpers';
import { BaseModel } from '../base.model';
import { McpToolClassification } from '.';

export class McpToolModel extends BaseModel {
  serverName: string;
  serverId: string;
  name: string;
  description: string;
  updatedAt: string;
  classification: McpToolClassification;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof McpToolModel, unknown>;

    this.serverName = data.serverName as string;
    this.serverId = data.serverId as string;
    this.name = data.name as string;
    this.description = data.description as string;
    this.updatedAt = data.updatedAt as string;
    this.classification = (data.classification as McpToolClassification) || { action: 'read' };
  }
}
